import { FlameChartTooltipSlot } from '../../shared/slots/Tooltip.js';
import { makeIterateSlots } from '../../shared/utils/make-iterate-slots.js';

export const iterateSlots = makeIterateSlots(FlameChartTooltipSlot);
